import * as React from 'react';
import { Box, Button, FlexBox, Grid, MuiBox, SvgIcon, SvgIconButton } from '@kis-technologies/kis-ui';
import { NumPadActionProps, ConfirmConfig } from '../types';
import { NumPad } from './NumPad';
import { CaretContainer, useStyles } from '../styled';
import { ForwardNavigationButton } from 'components/ForwardNavigationButton';

const baseConfig: ConfirmConfig = {
  appearance: 'primary',
  customSize: 'x-large',
  width: 475,
  label: 'Enter'
};

/**
 * Extension of the NumPad with a button
 */

export const NumPadAction = (props: NumPadActionProps) => {
  const {
    onClick,
    onConfirm,
    onBack,
    isConfirmDisabled,
    confirmConfig = baseConfig,
    isLoading,
    hideForwardPrompt,
    layout,
    onClickOutside,
    onCaretClick
  } = props;
  const { label, backLabel, ...rest } = confirmConfig;

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: any) => {
    if (
      event.target.tagName !== 'INPUT' &&
      event.target.tagName !== 'BODY' &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      if (onClickOutside) onClickOutside(event);
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  const classes = useStyles({ layout, backLabel })();

  return (
    <Box padding="2 0 2 0">
      <Grid ref={wrapperRef} className={classes.numPadOuterContainer}>
        {backLabel && (
          <MuiBox className={classes.backLabelBlockLandscape}>
            <Button
              isLoading={isLoading}
              onClick={onBack}
              {...rest}
              appearance="white"
              startIconName="prev_circle"
              className={classes.backLabelButton}
            >
              {backLabel}
            </Button>
          </MuiBox>
        )}
        <MuiBox className={classes.numPadBlock}>
          <NumPad onClick={onClick} />
        </MuiBox>
        <MuiBox className={classes.labelBlockContainer}>
          {backLabel && (
            <MuiBox className={classes.backLabelBlockPortarait}>
              <Button
                isLoading={isLoading}
                onClick={onBack}
                {...rest}
                appearance="white"
                startIconName="prev_circle"
                className={classes.backLabelButton}
              >
                {backLabel}
              </Button>
            </MuiBox>
          )}
          <MuiBox className={classes.numPadLabelBlock}>
            {hideForwardPrompt ? (
              <FlexBox sx={{ justifyContent: 'center' }}>
                <Button onClick={onConfirm} disabled={isConfirmDisabled} isLoading={isLoading} {...rest}>
                  {label}
                </Button>
              </FlexBox>
            ) : (
              <ForwardNavigationButton
                label={label}
                isDisabled={isConfirmDisabled}
                onClick={onConfirm}
                overflow="hidden"
              />
            )}
          </MuiBox>
        </MuiBox>
      </Grid>
      {onCaretClick && (
        <CaretContainer>
          <SvgIconButton
            onClick={onCaretClick}
            data-testid="numpad-caret"
            sx={{
              boxShadow: 'none'
            }}
            customTransition="opacity 0.2s linear"
          >
            <SvgIcon name="chevron_down" size={40} />
          </SvgIconButton>
        </CaretContainer>
      )}
    </Box>
  );
};
